export default __webpack_public_path__ + "static/media/gallery-wip-emitter_04.74c3fefb.jpg";